import React from 'react';

import clsx from 'clsx';

import { makeStyles, TableCell } from '@gogame/components';

import { useHighlightCell } from './Highlight/useHighlightCell';

const useStyles = makeStyles(
  {
    root: {
      paddingTop: 0,
      paddingBottom: 0,
      height: 31,
      '&:after': {
        right: 0,
      },
      background: ({ intensity }) => {
        if (!intensity) {
          return null;
        }

        return `rgba(253, 148, 72, ${intensity})`;
      },
    },
    highlighted: {
      '&&': {
        opacity: 1,
        background: ({ intensity, isHighlighted }) => {
          if (!intensity) {
            if (isHighlighted) {
              return 'rgba(0, 0, 0, 0.04)';
            } else {
              return null;
            }
          }

          return `rgba(253, 148, 72, ${intensity})`;
        },
        fontWeight: 'bold',
      },
    },
  },
  { name: 'CohortsCell' }
);

export const CohortsCell = ({
  children,
  className,
  column,
  row,
  intensity,
  ...props
}) => {
  const { isHighlighted, highlighting, ...highlightProps } = useHighlightCell({
    column,
    row,
  });
  const classes = useStyles({ intensity, highlighting, isHighlighted });

  const canHighlight = column !== undefined;
  return (
    <TableCell
      {...props}
      {...(canHighlight ? highlightProps : null)}
      className={clsx(className, classes.root, {
        [classes.highlighted]: isHighlighted,
      })}
    >
      {children}
    </TableCell>
  );
};

export default CohortsCell;
